import React from 'react';
import { passwordStrength } from '../../utils/passwordStrength';
import styles from './PasswordStrengthMeter.module.css';

/** Drop-in strength indicator for any "new password" field — SettingsPage (change/set
 * password), SignUp, ResetPassword. Renders nothing until the field has content. */
const PasswordStrengthMeter = ({ password }) => {
    if (!password) return null;
    const strength = passwordStrength(password);
    return (
        <div className={styles.meter} aria-hidden>
            <div className={styles.bars}>
                {[0, 1, 2, 3].map((i) => (
                    <div
                        key={i}
                        className={`${styles.bar} ${i < strength.score ? styles.barFilled : ''}`}
                        style={i < strength.score ? { '--strength-color': strength.color } : undefined}
                    />
                ))}
            </div>
            <span className={styles.label} style={{ '--strength-color': strength.color }}>
                {strength.label}
            </span>
        </div>
    );
};

export default PasswordStrengthMeter;
